// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rentalId: __t.u64().primaryKey().name("rental_id"),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  renter: __t.identity(),
  upfrontSov: __t.i64().name("upfront_sov"),
  collateralVouch: __t.bool().name("collateral_vouch"),
  startsAt: __t.timestamp().name("starts_at"),
  endsAt: __t.timestamp().name("ends_at"),
  returnedClean: __t.bool().name("returned_clean"),
  active: __t.bool(),
});
